import { useOutletContext } from "react-router-dom";
import CargoDetails from "./CargoDetails";
import DeliveryNotesDocuments from "./DeliveryNotesDocuments";
import JobDetails from "./JobDetails";
import TruckGatepassDetails from "./TruckGatepassDetails";
import type { TruckGatepassOutletContext } from "./types";
import { useTruckEntryDateSync } from "./useTruckEntryDateSync";
import VehicleDetails from "./VehicleDetails";
import VisitorDetails from "./VisitorDetails";

const TruckGatepass = () => {
  const { formData, updateFormData } = useOutletContext<TruckGatepassOutletContext>();
  useTruckEntryDateSync(formData, updateFormData);

  return (
    <div data-testid="truck-gatepass-form" className="flex flex-col gap-8">
      <VisitorDetails />
      <TruckGatepassDetails />
      <JobDetails />
      <CargoDetails />
      <DeliveryNotesDocuments />
      <VehicleDetails />
    </div>
  );
};

export default TruckGatepass;
